export const MAX_SECTION_WIDTH = 1600;
